import { useEffect, useRef, useState } from "react";
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import Linkify from "linkify-react";
import moment from "moment";
import { Link } from "react-router-dom";
import SinglePostInteraction from "./SinglePostInteraction";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import LikesDetails from "./LikesDetails";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ReplyAllOutlinedIcon from '@mui/icons-material/ReplyAllOutlined';

import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";



import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { post, people } from "../../config/imagesLink";
import { ImageWithLoader } from "@skeleton";
import formatPostContent, {
  formatExpandedPostContent,
} from "../../utility/formatPostContent";
import shouldShowPostReadMore from "../../utility/shouldShowPostReadMore";
import PollCard from "./PollCard";

const PostComponent = ({
  item,
  restrictedViewerToken,
  isOpen,
  isModalView,
  redirectBlockedMessage,
}) => {
  const guestModeData = localStorage.getItem("guestMode");
  const getToken = localStorage.getItem("restrictedViewerToken");
  const [postContentMap, setPostContentMap] = useState({});
  const language = localStorage.getItem("Lang");
   const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";

  const [userData, setUserData] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const [errorImage, setErrorImage] = useState(false);
  const uid = item?.postInfo?.sharedPost?.postOriginId;
  const [imageArray, setImageArray] = useState([]);
  const [initialSlideIndex, setInitialSlideIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [sharedPostContent, setSharedPostContent] = useState({});
 const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);
  const [postLikedType, setPostLikedType] = useState(false);
  const [postId, setPostId] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const [warningToastMessage, setWarningToastMessage] = useState("");
  // const [initialSlideIndex, setInitialSlideIndex] = useState(0);
  // const [imageArray, setImageArray] = useState([]);

  const handleShowModal = (item) => {
    setPostId(item?.postInfo?.sharedPost?.postId);
    setPostLikedType(item?.postInfo?.sharedPost?.likedType);
    setShowModal(true);
  };
  const handleLikesCloseModal = () => {
    setShowModal(false);
  };

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  const handlePostMediaImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = post.noimgavailable;
  };

  const openModal = (images) => {
    // console.log('clicke');
    setModalImages(images);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleBlockedRedirect = (event) => {
    if (!redirectBlockedMessage) return;

    event.preventDefault();
    event.stopPropagation();
    setWarningToastMessage(redirectBlockedMessage);
    setShowWarningToast(true);
  };
const [expandedPosts, setExpandedPosts] = useState({});

  const readMore = async (id) => {
  try {
    // If content already exists, just expand
    if (postContentMap[id]) {
      setExpandedPosts((prev) => ({ ...prev, [id]: true }));
      return;
    }

    const res = await axios.get(
      `/Posts/GetPostMainContent?DeviceType=Web&PostId=${id}&langKey=${language}`
    );

    setPostContentMap((prev) => ({
      ...prev,
      [id]: res.data.responseData,
    }));

    setExpandedPosts((prev) => ({
      ...prev,
      [id]: true,
    }));
  } catch (error) {
    console.log(error);
  }
};

  console.log("postContentMap", postContentMap);

  //   const getUserProfile = () => {
  //     setIsloading(true);
  //     const data = {
  //       deviceType: "Web",
  //       userUid: uid,
  //     };
  //     axios
  //       .post(`UserProfile/GetUserProfile`, data)
  //       .then((response) => {
  //         console.log("responseData", response);
  //         if (response.status === 204) {
  //           setErrorImage(true);
  //         } else {
  //           const res = response.data.responseData;
  //           setUserData(res);
  //           setIsloading(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setIsloading(false);
  //       });
  //   };
  //   useEffect(() => {
  //     getUserProfile();
  //   }, [uid]);

  const commentedPost = (item) =>
    formatPostContent(
      item?.postInfo?.postContent,
      item?.postInfo?.dynamicValues
    );

  const processExpandedContent = formatExpandedPostContent;

  const sharedPostFormattedContent = formatPostContent(
    item?.postInfo?.sharedPost?.postContent,
    item?.postInfo?.sharedPost?.dynamicValues
  );

  console.log("consoling item", item);

  const videoRef = useRef(null);

  // useEffect(() => {
  //   const videoId = item?.postInfo?.mediaFilesList?.[0]?.mediaInfo || item?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaInfo;
  //   const accountId = "3933d146-5f68-41d4-93a3-d2f7454d4a8d";
  //   const region = "centralindia";

  //   console.log("videoId:", videoId);
  //   console.log("token:111", getToken);

  //   if (!videoId || !getToken || !videoRef.current) {
  //     console.error("Missing videoId or token or ref.");
  //     return;
  //   }

  //   const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: getToken, region: region });
  //   console.log("manifestUrl:", manifestUrl);
  //   let hls;
  //   let plyrInstance;

  //   if (Hls.isSupported()) {
  //     hls = new Hls();
  //     hls.loadSource(manifestUrl);
  //     hls.attachMedia(videoRef.current);

  //     hls.on(Hls.Events.MANIFEST_PARSED, () => {
  //       console.log("✅ Manifest parsed");
  //       plyrInstance = new Plyr(videoRef.current, {
  //         captions: { active: true, update: true, language: "en" },
  //       });

  //       // Wait for a short time, then try to play

  //       videoRef.current?.play().catch(err => {
  //         console.warn("Play interrupted", err);
  //       });

  //     });

  //     hls.on(Hls.Events.ERROR, (event, data) => {
  //       console.error("HLS.js Error:", data);
  //     });
  //   } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
  //     console.log("✅ Native HLS fallback");
  //     videoRef.current.src = manifestUrl;
  //     // plyrInstance = new Plyr(videoRef.current);
  //     videoRef.current.addEventListener("loadedmetadata", () => {
  //       videoRef.current?.play();
  //     });
  //   }
  //   return () => {
  //     // if (plyrInstance) plyrInstance.destroy();
  //     if (hls) hls.destroy();
  //   };
  // }, [item, restrictedViewerToken]);



 const getRelativeTime = (item) => {
  const now = moment.utc().local();
  const itemTime = moment
    .utc(item?.postInfo?.creationTime)
    .local();

  const diffSeconds = now.diff(itemTime, "seconds");
  const diffMinutes = now.diff(itemTime, "minutes");
  const diffHours = now.diff(itemTime, "hours");
  const diffDays = now.diff(itemTime, "days");
  const diffMonths = now.diff(itemTime, "months", true);
  const diffYears = now.diff(itemTime, "years", true);

  /* JUST NOW */
  if (diffSeconds < 60) {
    return t("Notifications.Just Now");
  }

  /* MINUTES */
  if (diffMinutes < 60) {
    return diffMinutes === 1
      ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
      : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
  }

  /* HOURS */
  if (diffHours < 24) {
    return diffHours === 1
      ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
      : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
  }

  /* DAYS */
  if (diffDays < 30) {
    return diffDays === 1
      ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
      : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
  }

  /* MONTHS */
  if (diffMonths < 12) {
    const displayMonth =
      diffMonths >= 0.75 && diffMonths < 1.25
        ? 1
        : Math.round(diffMonths * 2) / 2;

    return displayMonth === 1
      ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
      : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
  }

  /* YEARS */
  const displayYear =
    diffYears >= 0.75 && diffYears < 1.25
      ? 1
      : Math.round(diffYears * 2) / 2;

  return displayYear === 1
    ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
    : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
};

  useEffect(() => {
    const videoId =
      item?.postInfo?.mediaFilesList?.[0]?.mediaInfo ||
      item?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaInfo;
    // const accountId = "3933d146-5f68-41d4-93a3-d2f7454d4a8d";
    const region = "centralindia";

    if (!videoId || !getToken || !videoRef.current) {
      console.error("Missing videoId, token, or ref.");
      return;
    }

    const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: getToken, region: region });
    let hls;
    let plyrInstance;
    let hasInitialized = false;

    const initPlayer = () => {
      if (hasInitialized) return; // Prevent re-init
      hasInitialized = true;

      if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(manifestUrl);
        hls.attachMedia(videoRef.current);

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          // plyrInstance = new Plyr(videoRef.current, {
          //   captions: { active: true, update: true, language: "en" },
          //   muted: true,
          //   volume: 0,  // starts muted but volume slider available
          //   // controls: ['play', 'progress', 'volume', 'fullscreen', 'settings', 'captions'], // explicitly show volume control

          // });
          plyrInstance = new Plyr(videoRef.current, {
            captions: { active: true, update: true, language: "en" },
          });
          videoRef.muted = true; // always start muted
          videoRef.play().catch((e) => console.warn("Autoplay error", e));

        });

        hls.on(Hls.Events.ERROR, (event, data) => {
          console.error("HLS.js Error:", data);
        });
      } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
        videoRef.current.src = manifestUrl;
        videoRef.current.addEventListener("loadedmetadata", () => {
          plyrInstance = new Plyr(videoRef.current, {
            captions: { active: true, update: true, language: "en" },
            // muted: true,
            // volume: 0,  // starts muted but volume slider available
            // controls: ['play', 'progress', 'volume', 'fullscreen', 'settings', 'captions'], // explicitly show volume control

          });
          videoRef.muted = true; // always start muted
          videoRef.play().catch((e) => console.warn("Autoplay error", e));

        });
      }
    };

    // Intersection observer to control play/pause
    const observer = new IntersectionObserver(
      ([entry]) => {
        const isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.6;

        if (isVisible) {
          initPlayer();
          videoRef.current?.play().catch(err => {
            console.warn("Play interrupted", err);
          });
        } else {
          // videoRef.muted = true; // always start muted
          videoRef.current?.pause();
        }
      },
      { threshold: Array.from({ length: 11 }, (_, i) => i * 0.1) } // 0, 0.1, 0.2 ... 1
    );

    observer.observe(videoRef.current);

    return () => {
      observer.disconnect();
      if (plyrInstance && typeof plyrInstance.destroy === "function") {
        plyrInstance.destroy();
      }
      if (hls) hls.destroy();
    };
  }, [ item?.postInfo?.mediaFilesList?.[0]?.mediaInfo,item?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaInfo, getToken]);

  return (
    <>

      <div className="mb-0">

        {item?.cntntTypCategory === "Article" ? (
          <>
              {item?.postInfo?.postContent && (
                <div className="f-14 postContent article">
                   {!(isOpen && isModalView) && (
                  <>
                    {!expandedPosts?.[item.postInfo.postId] && (       
                      <Link
                        to={
                          item?.cntntTypCategory === "Article"
                            ? `/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`
                            : undefined
                        }
                        target="_blank"
                        onClick={handleBlockedRedirect}
                      >
                      <div
                        className="postContentDiv"
                        dangerouslySetInnerHTML={{
                          __html: commentedPost(item),
                        }}
                      />
                      </Link>
                    )}
                
                   {!expandedPosts?.[item.postInfo.postId] && 
                     shouldShowPostReadMore(item?.postInfo?.postContent, item?.postInfo?.readMore) && (
                      <span
                        style={{ color: "#1051b0" }}
                        onClick={() => readMore(item?.postInfo?.postId)}
                        className="pointer"
                      >
                       {t("Newsfeed.Read More")}
                      </span>
                    )}
                    {expandedPosts?.[item.postInfo.postId] &&
                      postContentMap?.[item.postInfo.postId] && (
                      <Link
                        to={`/Post/${item?.postInfo?.postId}`}
                        target="_blank"
                        onClick={handleBlockedRedirect}
                      >       
                        <div
                          className="postContentDiv f-14"
                          dangerouslySetInnerHTML={{
                            __html: processExpandedContent(
                              postContentMap?.[item.postInfo.postId],
                              item?.postInfo?.dynamicValues
                            ),
                          }}
                        />
                        </Link>
                      )}
                      {expandedPosts?.[item.postInfo.postId] && (
                          <span style={{color:"#1051b0"}}
                            className="pointer"
                            onClick={() =>
                              setExpandedPosts((prev) => ({
                                ...prev,
                                [item?.postInfo?.postId]: false,
                              }))
                            }
                          >  {t("Newsfeed.Read Less")}
                           </span>
                        )}
                    </>
                   )}
                </div>
              )}
          </>
        ) : (
          <>
            {item?.postInfo?.postContent && (
              <div className="f-14 p-2 postContent mb-0">
                {!(isOpen && isModalView) && (
                  <>
                  {!expandedPosts?.[item.postInfo.postId] && (
                  <Link
                    to={`/Post/${item?.postInfo?.postId}`}
                    target="_blank"
                    onClick={handleBlockedRedirect}
                  >
                    <div
                      className="postContentDiv f-14"
                      dangerouslySetInnerHTML={{
                        __html: commentedPost(item),
                      }}
                    />
                    </Link>
                  )}
 
                  {!expandedPosts?.[item.postInfo.postId] &&
                  shouldShowPostReadMore(item?.postInfo?.postContent, item?.postInfo?.readMore) && (
                    <span style={{color:"#1051b0"}}
                      onClick={() => readMore(item.postInfo.postId)}
                      className="pointer"
                    >
                      {t("Newsfeed.Read More")}
                    </span>
                  )}
              
                  {expandedPosts?.[item.postInfo.postId] &&
                  postContentMap?.[item.postInfo.postId] && (
                   <Link
                    to={`/Post/${item?.postInfo?.postId}`}
                    target="_blank"
                    onClick={handleBlockedRedirect}
                   >       
                    <div
                      className="postContentDiv f-14"
                      dangerouslySetInnerHTML={{
                        __html: processExpandedContent(
                          postContentMap?.[item.postInfo.postId],
                          item?.postInfo?.dynamicValues
                        ),
                      }}
                    />
                    </Link>
                  )}

                   {expandedPosts?.[item.postInfo.postId] && (
                  <span style={{color:"#1051b0"}}
                    className="pointer"
                    onClick={() =>
                      setExpandedPosts((prev) => ({
                        ...prev,
                        [item?.postInfo?.postId]: false,
                      }))
                    }
                  >
                  {t("Newsfeed.Read Less")}
                  </span>
                  )}

                  </>
                )}
              </div>
            )}
              
          </>
        )}

        {item?.postInfo?.postId && !item?.postInfo?.sharedPost && (
          <div className="px-2">
            <PollCard postId={item.postInfo.postId} />
          </div>
        )}

        {item?.postInfo?.sharedPost ? (
          <>
            <div className="row w-94 m-0 singlePostLink">
              <div className="featured-card user-postOnlyContent wlj-shared-original">
                <div className="feature-content p-2 d-flex justify-content-between align-items-center">
                  {item?.postInfo?.sharedPost?.postOriginType === "Company" ? (
                    <Link
                      to={`/Company/${item?.postInfo?.sharedPost?.userUid}`}
                    >
                      <div className="d-flex align-items-center">
                        <div className="ImgAvatar">
                          <img
                            src={item?.postInfo?.sharedPost?.userAvatar}
                            alt=""
                            style={{ borderRadius: "50px" }}
                            onError={handleProfileImageError}
                          />
                        </div>
                        <div className="ms-2">
                          <h4 className="f-14 fw-bold mb-0">
                            {item?.postInfo?.sharedPost?.userName}
                          </h4>
                          {/* <p className="f-12"> 
                            {moment
                              .utc(item?.postInfo?.sharedPost?.creationTime)
                              .local()
                              .format("DD MMMM YYYY [at] h:mm a")}
                             </p> */}
                                    {language === "ar" ? (
                                       <Tooltip title={moment
                                                  .utc(item?.postInfo?.sharedPost?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                              <p className="f-10 label"> 
                                                {moment
                                                  .utc(item?.postInfo?.sharedPost?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")}
                                              </p>
                                           </Tooltip>
                                        ) : (
                                          <Tooltip title={moment
                                                  .utc(item?.postInfo?.sharedPost?.creationTime)
                                                  .local()
                                                  .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <p className="f-10 label"> 
                                          {getRelativeTime(item)}</p>
                                           </Tooltip>
                                            

                                        )}

                        </div>
                      </div>
                    </Link>
                  ) : (
                    <Link to={`/User/${item?.postInfo?.sharedPost?.userUid}`}>
                      <div className="d-flex align-items-center">
                        <div className="ImgAvatar">
                          <img
                            src={item?.postInfo?.sharedPost?.userAvatar}
                            alt=""
                            style={{ borderRadius: "50px" }}
                            onError={handleProfileImageError}
                          />
                        </div>
                        <div className="ms-2">
                          <h4 className="f-14 fw-bold mb-0">
                            {item?.postInfo?.sharedPost?.userName}
                          </h4>
                          {/* <p className="f-12">
                            {moment
                              .utc(item?.postInfo?.sharedPost?.creationTime)
                              .local()
                              .format("DD MMMM YYYY [at] h:mm a")}
                          </p> */}
                              {language === "ar" ? (
                                                  <Tooltip title={moment
                                                  .utc(item?.postInfo?.sharedPost?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                              <p className="f-10 label"> 
                                                {moment
                                                  .utc(item?.postInfo?.sharedPost?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")}
                                              </p>
                                           </Tooltip>
                                        ) : (
                                          <Tooltip title={moment
                                                  .utc(item?.postInfo?.sharedPost?.creationTime)
                                                  .local()
                                                  .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <p className="f-10 label"> 
                                          {getRelativeTime(item)}</p>
                                           </Tooltip>
                                            

                                        )}

                        </div>
                      </div>
                    </Link>
                  )}
                  <span className="wlj-shared-original-poll-badge badge badge-subtle badge-info1 f-12">
                    {t("Newsfeed.Poll")}
                  </span>

                  {/* {guestModeData === "true" ? null : (
                    <div className="row">
                      <div>
                        <SinglePostInteraction
                          postId={item?.postInfo?.sharedPost?.postId}
                        // AllPostList={AllPostList}
                        // ite.sharedPost={item?.sharedPost}
                        // setitem?.sharedPost={setitem?.sharedPost}
                        // isfollowed={isfollowed}
                        // setIsfollowed={setIsfollowed}
                        />
                      </div>
                    </div>
                  )} */}
                </div>
                    <div className="f-12 p-2 postContent">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sharedPostFormattedContent,
                        }}
                      />
                    </div>
                {item?.postInfo?.sharedPost?.postId && (
                  <div className="wlj-shared-original-poll px-2 pb-1">
                    <PollCard postId={item.postInfo.sharedPost.postId} nested />
                  </div>
                )}
                {item?.postInfo?.sharedPost.mediaFilesList && (
                  <>
                    <div
                      className="feed-post"
                      style={{
                        paddingTop:
                          item?.postInfo?.sharedPost?.postMediaCount === 0
                            ? "60px"
                            : "4px",
                      }}
                    >
                      <div className="row">
                        {item?.postInfo?.sharedPost?.mediaFilesList?.slice(0, 4)?.map(
                          (file, idx) => (
                            <div
                              key={idx}
                              className={`col-${item?.postInfo?.sharedPost?.mediaFilesList
                                .length === 1
                                ? "12"
                                : "6"
                                } ${item?.postInfo?.sharedPost?.mediaFilesList
                                  .length === 3 && idx === 0
                                  ? "col-12"
                                  : ""
                                }`}
                              style={{
                                position: "relative",
                                cursor: 'pointer',
                                padding:
                                  item?.postInfo?.sharedPost?.mediaFilesList
                                    .length === 3 && idx === 0
                                    ? "0 0 5px 0"
                                    : item?.postInfo?.sharedPost?.mediaFilesList
                                      .length === 3 && idx === 1
                                      ? "0 5px 5px 0"
                                      : item?.postInfo?.sharedPost?.mediaFilesList
                                        .length === 4 && idx === 2
                                        ? "0 5px 0 0"
                                        : item?.postInfo?.sharedPost?.mediaFilesList
                                          .length === 4 && idx === 0
                                          ? "0 5px 5px 0"
                                          : item?.postInfo?.sharedPost?.mediaFilesList
                                            .length === 2 && idx === 0
                                            ? "0 5px 5px 0"
                                            : "",
                              }}>

                              <h2>{file.length}</h2>
                              {/* <img
                                src={file.mediaName}
                                alt=""
                                className="img-fluid"
                                width={"100%"}
                              /> */}
                              {file.mediaType === "Image" ? (
                                <Link to={`/post/${item?.postInfo?.sharedPost?.postId}`} target="_blank">
                                  <ImageWithLoader
                                    src={`${file.mediaName}`}
                                    alt=""
                                    className="img-fluid modal-imag"
                                    width="100%"
                                    onError={handlePostMediaImageError}
                                  />
                                </Link>

                              )
                                :
                                // file.mediaType.length > 1 ? (
                                // //  <Link to={`/post/${item?.postInfo?.sharedPost?.postId}`} target="_blank">
                                //     <img
                                //       src={`${file.mediaName}`}
                                //       alt=""
                                //       className="img-fluid"
                                //       width="100%"
                                //       style={{ maxHeight: "250px" }}
                                //     />
                                // //  </Link>

                                // ) :
                                (
                                 <div  >

                                   <video
                                     key={item?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaInfo} 
                                     ref={videoRef}
                                     controls
                                     autoPlay={false}
                                     muted
                                     width="100%" 
                                     playsInline 
                                    //  className="video-player video-js" 
                                     style={{ aspectRatio: '16/9', width: '100%', height: 'auto' }} 

                                   /> 
                                 </div>

                                )}

                              {idx === 3 &&
                                item?.postInfo?.sharedPost?.postMediaCount >
                                4 && (
                                  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                    +
                                    {item?.postInfo?.sharedPost
                                      ?.postMediaCount - 4}
                                    {/* {item?.postInfo?.sharedPost?.commentCount} */}
                                  </div>
                                )}

                            </div>
                          ))}

                        <div
                          className={`postData d-flex align-items-center`}>
                          <div
                            style={{
                              marginLeft:
                                item?.contentInfo?.count === 3
                                  ? "32px"
                                  : "10px",
                            }}
                          >
                            {item?.postInfo?.sharedPost?.likeCount === 0 || item?.postInfo?.sharedPost?.likeCount === null ? (
                              ""
                            ) : (
                              <p
                                className="f-10 like-details"
                                onClick={() => handleShowModal(item)}
                              >
                                {item?.postInfo?.postReactionContent?.text}{" "}
                                {item?.postInfo?.sharedPost?.likeCount} <ThumbUpOutlinedIcon  style={{color:"#00419f",  fontSize: "13px"}}/>
                                {/* {t("Newsfeed.Like")} */}
                              </p>
                            )}
                          </div>
                          <div className="ms-auto d-flex">
                            {item?.postInfo?.sharedPost?.commentCount === 0 || item?.postInfo?.sharedPost?.commentCount === null ? (
                              ""
                            ) : (
                              <p
                                className="f-10 me-2 pointer"
                              // onClick={() => {
                              //   openModal(
                              //     item?.postInfo?.mediaFilesList?.map(
                              //       (file) => file.mediaName
                              //     )
                              //   );
                              //   // setSinglePostContent(item);
                              //   setSinglePostId(item?.postInfo?.postId);
                              // }}
                              >
                                {" "}
                                {item?.postInfo?.sharedPost?.commentCount} <ChatOutlinedIcon 
                                 style={{color:"#00419f", fontSize: "13px"}}/>
                                {/* {t("Newsfeed.Comment")} */}
                              </p>
                            )}

                            <p className="f-10">
                              {/* {item?.postInfo?.sharedPost?.shareCount === 0 || item?.postInfo?.sharedPost?.shareCount === null
                                ? ""
                                : `& ${item?.postInfo?.sharedPost?.shareCount}  ${t("Newsfeed.Share")}`} */}

                                {item?.postInfo?.sharedPost?.shareCount === 0 || item?.postInfo?.sharedPost?.shareCount === null
                                    ? ""
                                    : `&  ${item?.postInfo?.sharedPost?.shareCount}`} {item?.postInfo?.sharedPost?.shareCount === 0 || item?.postInfo?.sharedPost?.shareCount === null
                                    ? ""
                                    : <ReplyAllOutlinedIcon className=" ms-1" style={{color:"#00419f",fontSize: "13px"}} />
                                     }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>


      <LikesDetails
        showModal={showModal}
        handleLikesCloseModal={handleLikesCloseModal}
        postId={postId}
        postLikedType={postLikedType}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />
      {/* } */}
    </>
  );
};

export default PostComponent;